export const returnCommonVariables = () => {
    let isProd = false;
    let hostArray = window.location.href.split(".");
    if (hostArray.length > 1) {
        if (hostArray[1] !== 'dev') {
            isProd = true;
        }
    }
    // console.log("isProd - " + isProd);
    if (isProd === true) {
        return {
            "graphQLURL": "https://publicwebbackends.omax.com/prod/graphql",
            "loginURL": "https://support.omax.com"
        }
    }
    else {
        return {
            "graphQLURL": "https://publicwebbackends.omax.com/dev/graphql",
            "loginURL": "https://support.dev.omax.com"
        }
    }
}